import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { Button, Form, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCsrfCookie } from '../../../../../redux/action/csrf/csrf-cookie';
import { fetchSingleNewsData } from '../../../../../redux/action/homePage/news/homeSingleNews';
import MainLoading from '../../../../../utils/MainLoading';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import { toast } from 'react-toastify';
import default_image_url from '../../../../../redux/api/API';
import SimpleReactValidator from 'simple-react-validator';
import { useTranslation } from 'react-i18next';

const EditModal = (props) => {
    const [btnLoading, setBtnLoading] = useState(false)
    const [photo, setPhoto] = useState('')
    const [forceUpdate, setForceUpdate] = useState(0)
    const [uploadPercentage, setUploadPercentage] = useState(0)
    const [progerssbar, setProgressbar] = useState(0)
    const [selectedImage, setSelectedImage] = useState();
    const {t} = useTranslation();
    const [data, setData] = useState({
        title: '',
        description: '',
    })
    const [editorState, setEditorState] = useState('')
    const single_news = useSelector(state => state.single_news)
    const dispatch = useDispatch()

    const handleDataChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const handleSelectImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setSelectedImage(e.target.files[0]);
        }
        setPhoto(e.target.files[0])
    }

    const removeSelectedImage = () => {
        setSelectedImage();
        setPhoto()
    }

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است"
        },
    }))

    const onEditorStateChange = (editorState) => {
        setEditorState(editorState);
    }

    useEffect(() => {
        dispatch(fetchSingleNewsData(props.id))
    }, [props.id])

    useEffect(() => {
        const blocksFromHtml = htmlToDraft(single_news.single_news.description ? single_news.single_news.description : '');
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        setData({
            title: single_news.single_news.title ? single_news.single_news.title: '' ,
            description: single_news.single_news.description ? single_news.single_news.description : ''
        })
        setEditorState(EditorState.createWithContent(contentState))
    }, [single_news.single_news])


    const handleFromSubmit = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            setProgressbar(true)
            setBtnLoading(false)
            dispatch(fetchCsrfCookie())

            const formData = new FormData();
            formData.append('_method', 'PUT')
            formData.append('title', data.title)
            formData.append('description', draftToHtml(convertToRaw(editorState.getCurrentContent())))
            formData.append('image', photo)

            const config = {
                headers: { 'Content-Type': 'multipart/form-data' },

                onUploadProgress: (progressEvent) => {
                    const {loaded, total} = progressEvent;
                    let percent = Math.floor( (loaded * 100) / total )
            
                    if( percent < 100 ){
                        setUploadPercentage(percent)
                    }
                }
            }

            axios.post(`admin/news/${props.id}`, formData, config)
            .then(res => {
                setUploadPercentage(100)
                setTimeout(() => {
                    setUploadPercentage(0)
                }, 1000);
                setPhoto()
                setSelectedImage()
                toast.dismiss()	
                toast.success(t("toast_successfully_edited") , {position: 'bottom-right',className: 'foo-bar'})
                props.update()
            })
            .catch(err => {
                setBtnLoading(false)
                console.log(err)
                if(err.response.status === 403) {
                    setPhoto()
                    setSelectedImage()
                    setProgressbar()
                    toast.dismiss()
                    toast.error(t("toast_content_not_valid") , {position: 'bottom-right',className: 'foo-bar'})
                } else {
                    setPhoto()
                    setSelectedImage()
                    setProgressbar()
                    toast.dismiss()
                    toast.error(t("toast_something_went_wrong") , {position: 'bottom-right',className: 'foo-bar'})
                }
            })
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }
    }

    return (
        <>
            {props.show && (
                <Modal show={props.show} size='lg'>
                    <Modal.Header>
                        <Modal.Title>{t("management")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {single_news.loading ?
                            <MainLoading />
                        :
                            <Form className='col-lg-12' onSubmit={handleFromSubmit}>
                                <Form.Group className="mb-3" controlId="formTitle">
                                    <Form.Label><strong>{t("title")} :</strong></Form.Label>
                                    <Form.Control type="text" name="title" value={data.title} onChange={handleDataChange}  />
                                    <span className='validator_error'>{validator.current.message('title', data.title, 'required')}</span>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="formDescription">
                                    <Form.Label><strong>{t("text")} :</strong></Form.Label>
                                    <Editor
                                        editorState={editorState}
                                        wrapperClassName="texteditor-wrapper"
                                        editorClassName="texteditor-editor"
                                        onEditorStateChange={onEditorStateChange}
                                    />  
                                </Form.Group>
                                <Row>
                                    <div className='mt-4'>
                                        <p>{t("The maximum accepted image size is 2 MB")}</p>
                                        <p>{t("The_selected_image_format_must_be_one_of_the_following_jpeg_png_jpg_gif_svg")}</p>
                                    </div>
                                    {single_news.single_news.image &&
                                        <div className='main_photo news_photo col-lg-3 col-6'>
                                            <span>{t("news current picture")}</span>
                                            <img alt="news" src={default_image_url+single_news.single_news.image.path} />
                                        </div>
                                    }
                                    {selectedImage ? 
                                        <div className='selectedImage col-lg-3'>
                                            <img
                                                src={URL.createObjectURL(selectedImage)}
                                                alt="Thumb"
                                            />
                                            <button className='btn btn-danger remove_selected_image' type='button' onClick={removeSelectedImage}>
                                                <i className='fa fa-times'></i>
                                            </button>
                                        </div>
                                    :
                                        <div className='selectImage col-lg-3'>
                                            <div className='chooseForm'>
                                                <input type="file" className='create_new_image_input' name="photo" value={photo} onChange={handleSelectImage}/>
                                                <i className='fa fa-plus'></i>
                                                <span>{t("choose new picture")}</span>
                                            </div>
                                        </div>
                                    }
                                    
                                </Row>
                                <Button variant="success" type="submit" className='px-4 mt-2' disabled={btnLoading ? true : false}>
                                    {t("submit")}
                                </Button>
                            </Form>
                        }
                        
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={props.handleClick}>
                            {t("Cancel")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    )
}

export default EditModal
